<template>
	<vs-prompt
		@cancel="date = ''; about = ''"
		@accept="createTask"
		:active.sync="popupActive"
		:title="$t('addTask')"
		:acceptText="$t('save')"
		:cancelText="$t('cancel')"
		class="add-order-task"
	>
		<div>
			<vx-input-group class="mb-4">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary"
				>
					<label class="vs-input--label">{{ $t('chooseDate') }}</label>
					<div class="vs-con-input"></div>
					<vs-datepicker
						v-model="date"
						format="dd.MM.yyyy"
						v-validate="'required'"
						:to="minDate"
						name="date"
						type="datetime"
					></vs-datepicker>
				</div>
				<span v-if="errors.first('date')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</vx-input-group>
			<div class="vs-component vs-con-input-label vs-input vs-input-primary">
				<label class="vs-input--label">{{ $t('description') }}</label>
				<div class="vs-con-input"></div>
				<vs-textarea
					v-model="about"
					name="about"
					v-validate="'required|min:3|max:300'"
					rows="4"
					class="mb-0"
				/>
			</div>
			<span v-if="errors.first('about')" class="text-danger text-sm">
				{{ $t('fieldFilledIncorrect') }}
			</span>
		</div>
	</vs-prompt>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import moment from "moment";

export default {
	name: "AddOrderTask",
	mixins: [databaseManager, notifier],
	props: {
		active: { required: true, type: Boolean },
		order: { required: true },
		mode: { type: String, default: "order" }
	},
	data() {
		return {
			date: new Date(),
			about: "",
		}
	},
	watch: {
		popupActive(value) {
			if(value) return;
			this.date = new Date();
			this.about = "";
		}
	},
	computed: {
		minDate() {
			return new Date();
		},
		popupActive: {
			get() {
				return this.active;
			},
			set(newValue) {
				this.$emit("update:active", newValue);
			}
		},
	},
	methods: {
		async createTask() {
			this.popupActive = true;

			if(await this.$validator.validateAll() !== true) return;

			try {
				let newTask = null;

				if(this.mode === "order") {
				 	newTask = await this.dbCreateTask(this.date, this.about, this.order.id);
				} else if(this.mode === "client") {
					newTask = await this.dbCreateTaskToClient(this.date, this.about, this.order.id);
				}

				this.about = "";
				this.date = new Date();
				this.popupActive = false;

				if(!!this.order) {
					this.order.task = newTask;
				}

				this.notifySuccess(this.$t('addedSuccessfully'));

			} catch (e) {
				this.notifyError(e.message)
			}
		},
	}
};
</script>

<style lang="scss">
.add-order-task {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}
</style>
